import Flags from './flags/_index.js'
import Logos from './logos/_index.js'

let icons = Flags
icons = Object.assign(icons, Logos)

export default icons